module.exports = __webpack_public_path__ + "img/404error.fc8bb876.webp";